<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <UsersTable />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import UsersTable from "./components/UsersTable";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    UsersTable,
    // ProjectsTable,
  },
};
</script>
